export default {"src":"/_next/static/media/envelope.94e02dda.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};